export interface AlertProps { 
    icon?: string; 
    message?: string; 
    severity?: SEVERITY,
    duration?: number
}

export enum SEVERITY {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info'
}